import ICONS from "../../../../../assets/Icons";
import TaxationTransactionViewAll from "../../../../../containers/Transactions/TaxationTransactions/TaxationTransactionViewAll";
import globalText from "../../../../../utils/globalText";
import AssignLabels from "../../../../_utils/AccountCreationComponents/AssignLabels";
import SingleOptionSelector from "../../../../_utils/AccountCreationComponents/SingleOptionSelector";
import CommonLayout from "../../../../_utils/CommonLayout";
import LargePopupRedirect from "../../../../_utils/CommonPopups/CommonLargePopupRedirect";
import AdditionalDetailsPreviewMapper from "../../../../_utils/TransactionCommonComponents/AdditionalDetailsPreviewMapper";
import Amount from "../../../../_utils/TransactionCommonComponents/Amount";
import CategorySelector from "../../../../_utils/TransactionCommonComponents/CategorySelector";
import ConfidentialCard from "../../../../_utils/TransactionCommonComponents/ConfidentialCard";
import PaymentMethodSelector from "../../../../_utils/TransactionCommonComponents/PaymentMethodSelector";
import SourceDestinationAccountDetail from "../../../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";

const TaxTransactionStepConfirm = (props) => {
  const allLabels = [
    ...new Set([
      ...(props?.txnPayLoad?.labels || []),
      ...(props?.txnPayLoad?.ownerLabels || []),
    ]),
  ];
  const formatCategory = (text) => {
    if (!text) return "";

    const upperCaseWords = ["tds", "gst", "pt"];

    return text
      .replaceAll("_", " ")
      .toLowerCase()
      .split(" ")
      .map((word) =>
        upperCaseWords.includes(word)
          ? word.toUpperCase()
          : word.charAt(0).toUpperCase() + word.slice(1),
      )
      .join(" ");
  };

  return (
    <>
      {props?.showSimilarModal && (
        <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <LargePopupRedirect
            headerTitle={"Similar transactions found"}
            headersubtext={
              "Transactions with similar details have already been created. Proceeding will result in a duplicate transaction."
            }
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => props?.setShowSimilarModal(false)}
            closeicon={ICONS?.CLOSE}
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            enabledBgColor={"var(--negative-act)"}
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={false}
            confirmbtnrequired={true}
            isbottomSectionneed={true}
            bottomHeaderTextNeed={true}
            btnText="Proceed with caution"
            handleFunction={() => {
              props?.setShowSimilarModal(false);
              props?.onForceCreate();
            }}
            bottomHeaderText={"Proceed with creating this transaction?"}
          >
            <TaxationTransactionViewAll
              TxnHistoryAccountName={
                props?.txnPayLoad?.taxAccountBankName || "NA"
              }
              txnHistoryid={props?.txnPayLoad?.taxAccountId || null}
              taxTxnconfidential={props?.txnPayLoad?.taxAccountId || null}
              onClose={() => {
                props?.setShowSimilarModal(false);
              }}
              queryParams={props?.queryParams}
              similarTxnType={"similarTxn"}
              popup={"modalType"}
              type={"tax_txnViewAll_popup"}
            />
          </LargePopupRedirect>
        </div>
      )}
      <div className="w-width-full flex flex-col Qlg:px-padding-base px-padding-md gap-gap-md Qsmd:py-padding-md pt-padding-md max-w-tab-width-normal mx-auto">
        <CommonLayout>
          <SourceDestinationAccountDetail
            type="source"
            txnPayLoad={props.txnPayLoad}
            setTxnPayLoad={props.setTxnPayLoad}
            page="confirm"
          />

          <SourceDestinationAccountDetail
            type="destination"
            flow="beneficiary"
            txnPayLoad={props.txnPayLoad}
            setTxnPayLoad={props.setTxnPayLoad}
            page="confirm"
          />
          <div className="flex flex-col w-full gap-y-gap-md">
            <Amount
              isPreview={true}
              txnPayLoad={props?.txnPayLoad}
            />
            <PaymentMethodSelector
              previewMode={true}
              showUnassignLink={false}
              selectedMethod={props?.txnPayLoad?.settleType}
            />
          </div>

          <ConfidentialCard
            icon={ICONS?.CONFIDENTIAL_TRANSACTION}
            title={globalText?.CREATE_AS_CONFIDENTIAL}
            note={globalText?.CONFIDENTIAL_TRANSACTION_NOTE}
            toggleState={props?.isConfidential}
            isPreview={true}
          />

          <CategorySelector
            previewMode={true}
            header={"Tax type"}
            selectedCategory={
              props?.txnPayLoad?.selectedCategory
                ? {
                    ...props.txnPayLoad.selectedCategory,
                    name: formatCategory(
                      props.txnPayLoad.selectedCategory.name,
                    ),
                  }
                : null
            }
            category={props?.txnPayLoad?.mergeCategory || []}
            IFSC={props?.txnPayLoad?.bankAccountIFSC}
            accountNumber={props?.txnPayLoad?.bankAccountNo}
            beneAccountId={props?.txnPayLoad?.taxAccountId}
            unassignCategories={[]}
            unassignlength={[]}
          />

          {props?.txnPayLoad?.selectedCategory?.name?.toLowerCase() === "tds" &&
            props?.txnPayLoad?.tax_section && (
              <div className="w-width-full lg:max-w-[var(--create-box-width)]">
                <SingleOptionSelector
                  previewMode={true}
                  title="Tax section"
                  selectedOption={{
                    name: props.txnPayLoad.tax_section.section_name,
                  }}
                  metaMap={{
                    [props?.txnPayLoad?.tax_section?.section_name?.toLowerCase()]:
                      {
                        description:
                          props?.txnPayLoad?.tax_section?.description,
                      },
                  }}
                  showIcon={false}
                  isSectionType={true}
                />
              </div>
            )}
          <AssignLabels
            labels={allLabels}
            previewMode={true}
            isOptional={true}
          />

          <div className="lg:max-w-[var(--create-box-width)] lg:w-width-full w-width-full">
            <AdditionalDetailsPreviewMapper
              mappingData={props.txnPayLoad.mergeCategory}
              previewImages={props?.previewImages}
            />
          </div>
        </CommonLayout>

        <div className="h-mobile-create-header w-width-full Qmd:hidden block"></div>
      </div>
    </>
  );
};

export default TaxTransactionStepConfirm;
